import { IGlobal } from "config/config.interface";
import { WindowContainer } from "lib/interfaces/user.interface";
import { IApiUri } from "../../interfaces/assessment.interface";

export const HideElement = (selector: string) => {
    const $ =  WindowContainer.GetWindow().$;
    const parent = $(selector).parents('.question-row')[0];
    $(parent).removeClass('showMe');
    $(parent).addClass('hideMe');
}

export const ShowElement = (selector: string) => {
    const $ =  WindowContainer.GetWindow().$;
    const parent = $(selector).parents('.question-row')[0];
    $(parent).removeClass('hideMe');
    $(parent).addClass('showMe');

}



export const getQuestionUri = (questionType: number): IApiUri => {
    const globalConfig = (global as any as IGlobal).config;

    let apiResponse = {
        answer: '',
        question: '',
        save: '',
    }
    switch (questionType) {
        case globalConfig.QUESTION_TYPE_FC:
            apiResponse = {
                answer: 'GetAnswerForcedChoice',
                question: 'GetQuestionForcedChoice',
                save: 'SaveQuestionForcedChoice'
            };
            break;
        case globalConfig.QUESTION_TYPE_MC:
            apiResponse = {
                answer: 'GetAnswerMultipleChoice',
                question: 'GetQuestionMultipleChoice',
                save: 'SaveQuestionMultipleChoice'
            };
            break;
        case globalConfig.QUESTION_TYPE_MS:
            apiResponse = {
                answer: 'GetAnswerMultipleSelect',
                question: 'GetQuestionMultipleChoice',
                save: 'SaveQuestionMultipleSelect'
            };
            break;
        case globalConfig.QUESTION_TYPE_AR:
            apiResponse = {
                answer: 'GetAnswerAnchoredRating',
                question: 'GetQuestionAnchoredRating',
                save: 'SaveQuestionAnchoredRating'
            };
            break;
        case globalConfig.QUESTION_TYPE_OE:
        case globalConfig.QUESTION_TYPE_SINGLELINE:
            apiResponse = {
                answer: 'GetAnswerOpenEnded',
                question: 'GetQuestionOpenEnded',
                save: 'SaveOpenEnded'
            };
            break;
        default:
            break;
    }
    return apiResponse;
}

	
export const cleanQuestionText = (dirtyResponse: string) => {	
    let cleanResponse = dirtyResponse === null ? "" : dirtyResponse;	
    cleanResponse = cleanResponse.replace(/&#8217;/g, "'"); //LEA Culture has code (&#8217;) for the "single quote" symbol	
    cleanResponse = cleanResponse.replace(/&#8220;/g, "\""); //LEA 360 (only Swedish) has code (&#8220;) for the "left double quote" symbol (“)	
    cleanResponse = cleanResponse.replace(/&#8221;/g, "\""); //LEA 360 (only Swedish) has code (&#8217;) for the "right double quote" symbol (”)	
    cleanResponse.trim();	
    return cleanResponse;	
}	
export const cleanApiResponse = (dirtyResponse: string) => {	
    let cleanResponse = dirtyResponse === null ? "" : dirtyResponse;	
    	
    /* ************ */	
    /* These next few are modern corrections for old code in the database */	
    //let cleanResponse = dirtyResponse.replace(/<br \/><br \/>/g, "</p><p>"); //removes <br><br>	
    	
    // The instructions currently (July 2022) contain onclick events and they need to be removed	
    //cleanResponse = cleanResponse.replace(/onclick/g, "onClick"); //makes the onclick event handler camelcase	
    cleanResponse = cleanResponse.replace(/onclick="uncheck\(\S{9}\s{1}\S{10}"/g, ""); //makes the onclick event handler camelcase	
    //onclick="uncheck(next_3_a, next_2_a);"	
    cleanResponse = cleanResponse.replace(/\s+</g, "<"); //removes one or more spaces in front of HTML tags	
    cleanResponse = cleanResponse.replace(/>\s+/g, ">"); //removes one or more spaces after HTML tags	
    	
    cleanResponse = cleanResponse.replace(/<p><div/g, "<div"); //<div> tags can not be descendants of <p> tags	
    cleanResponse = cleanResponse.replace(/<\/div><\/p>/g, "</div>"); //removes closing <p> tag that has a <div> descendant tag	
    cleanResponse = cleanResponse.replace(/<p>(.*?)<ul>/g, "<p>$1</p><ul>"); //<ul> tags can not be descendants of <p> tags	
    cleanResponse = cleanResponse.replace(/<\/ul><\/p>/g, "</ul>"); //removes closing <p> tag that has a <ul> descendant tag	
    cleanResponse = cleanResponse.replace(/<table(.*?)>/g, '<table$1><tbody>'); //modern <table> tags also need a <tbody> tag	
    cleanResponse = cleanResponse.replace(/(<span>.*<\/span>)<\/table>/g, "</table>$1"); //moves the <span> tage outside of the <table>	
    cleanResponse = cleanResponse.replace(/<\/table>/g, "</tbody></table>"); //closing the </tbody> tag	
    cleanResponse = cleanResponse.replace(/<tbody><tbody>/g, '<tbody>'); //you can not have multiple <tbody> tags in a row	
    cleanResponse = cleanResponse.replace(/<\/tbody><\/tbody>/g, '</tbody>'); //you can not have multiple <tbody> tags in a row	
    // FIXES FOR EMBEDDED HTML CODE FROM THE DATABASE	
    cleanResponse = cleanResponse.replace(/<b>/g, '<strong>'); //the <b> tag has been depreicated, we need to use the <strong> HTML tag	
    cleanResponse = cleanResponse.replace(/<\/b>/g, '</strong>'); //the <b> tag has been depreicated, we need to use the <strong> HTML tag	
    cleanResponse = cleanResponse.replace(/<strong>/g, ' <strong>'); //the extra space before the <strong> tag is needed in order to keep word boundaries apart	
    cleanResponse = cleanResponse.replace(/<\/strong>/g, '</strong> '); //the extra space after the </strong> tag is needed in order to keep word boundaries apart	
    cleanResponse = cleanResponse.replace(/<u>/g, '<em>'); //the <u> tag should be avoided because it can be confused as a hyperlink	
    cleanResponse = cleanResponse.replace(/<\/u>/g, '</em>'); //the <u> tag should be avoided because it can be confused as a hyperlink	
    cleanResponse = cleanResponse.replace(/<em>/g, ' <em>'); //the extra space before the <em> tag is needed in order to keep word boundaries apart	
    cleanResponse = cleanResponse.replace(/<\/em>/g, '</em> '); //the extra space after the </em> tag is needed in order to keep word boundaries apart	
    /* ************ */	
    cleanResponse.trim();	
    return cleanResponse;	
}